function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9781 14.9466C16.6251 14.7397 16.1912 14.744 15.8399 14.9527L14.0608 16.0127C13.6625 16.2501 13.1651 16.2223 12.7999 15.937C12.1686 15.444 11.1521 14.6144 10.2678 13.7301C9.38342 12.8458 8.55387 11.8293 8.06083 11.198C7.77561 10.8327 7.74779 10.3354 7.98517 9.93709L9.04517 8.15798C9.25473 7.80668 9.25647 7.36929 9.04951 7.01625L6.4391 2.55715C6.18606 2.12585 5.68345 1.91368 5.19737 2.03281C4.7252 2.14759 4.11216 2.42759 3.46956 3.07106C1.4574 5.08322 0.388716 8.47711 7.95561 16.044C15.5225 23.6109 18.9155 22.5431 20.9285 20.53C21.5729 19.8857 21.852 19.2718 21.9677 18.7988C22.0851 18.3135 21.8764 17.8144 21.4459 17.5622C20.3712 16.9336 18.0529 15.5762 16.9781 14.9466Z",
  fill: "#ABB1BB"
});

const SvgPhone = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/phone.488a73c2.svg";
export { ForwardRef as ReactComponent };